import { useEffect, useState } from "react"

//constants
import { ENDPOINTS } from "constants/endpoints"

//hooks
import useFetch from "hooks/useFetch"

function useFetchClientsTransactions(clientId, categoryId, startDate, endDate) {
    const { fetch, loading } = useFetch()

    const [transactions, setTransactions] = useState({})

    useEffect(() => {
        _fetchData()
    }, [startDate, categoryId, clientId,endDate])

    function _fetchData() {
        const params = `?task_type=${categoryId}&client=${clientId}&start_date=${startDate}&end_date=${endDate || 0}`

        fetch({ endpoint: `client-reference${params}`, method: 'get' })
            .then(res => {
                setTransactions(res.data)
            })
    }

    function getTransactions() {
        return transactions
    }

    function refetchData() {
        _fetchData()
    }

    return {
        getTransactions,
        loading,
        refetchData,
    }
}

export default useFetchClientsTransactions